import React from 'react';
import { Link } from 'react-router-dom';

// Text-based logo component matching the exact LUME style
function Logo({ className = "" }) {
  return (
    <span 
      className={className}
      style={{ 
        fontFamily: "'Playfair Display', Georgia, 'Times New Roman', serif",
        fontWeight: 600,
        letterSpacing: '0.05em'
      }}
    >
      LUME
    </span>
  );
}

export default function Footer() {
  return (
    <footer className="bg-white border-t border-neutral-100 pt-16 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-16">
          <div className="col-span-2 md:col-span-1">
            <Logo className="text-2xl text-black mb-4 block" />
            <p className="text-neutral-500 text-sm leading-relaxed">
              Personlig tilpassede kosttilskudd for en fokusert livsstil.
            </p>
          </div>
          
          <div>
            <h4 className="font-serif text-base mb-4">Utforsk</h4>
            <ul className="space-y-3 text-sm text-neutral-600">
              <li><Link to="/butikk" className="hover:text-black transition-colors">Butikk</Link></li>
              <li><Link to="/butikk?kategori=sovn" className="hover:text-black transition-colors">Søvn</Link></li>
              <li><Link to="/quiz" className="hover:text-black transition-colors">Ta quizen</Link></li>
              <li><Link to="/#bundles" className="hover:text-black transition-colors">Pakker</Link></li>
              <li><Link to="/helsetips" className="hover:text-black transition-colors">Helsetips</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-base mb-4">Informasjon</h4>
            <ul className="space-y-3 text-sm text-neutral-600">
              <li><Link to="/#faq" className="hover:text-black transition-colors">FAQ</Link></li>
              <li><Link to="/fornoydhetsgaranti" className="hover:text-black transition-colors">Fornøyd-garanti</Link></li>
              <li><a href="mailto:hei@lumewellness.no" className="hover:text-black transition-colors">Kontakt oss</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-base mb-4">Juridisk</h4>
            <ul className="space-y-3 text-sm text-neutral-600">
              <li><Link to="/personvern" className="hover:text-black transition-colors">Personvern</Link></li>
              <li><Link to="/vilkar" className="hover:text-black transition-colors">Vilkår</Link></li>
              <li><Link to="/cookies" className="hover:text-black transition-colors">Cookies</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-neutral-100 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-neutral-400">
            <p>© 2025 LUME. Alle rettigheter reservert.</p>
            <p className="max-w-md text-right">
              LUME gir ikke medisinske råd. Kosttilskudd er ment som et supplement til et variert kosthold og en sunn livsstil.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
